// ElsewhereOverlay (IMPLEMENTATION §2.9 single-instance lock, §3 M11): a newer tab / window took the save;
// this one stopped saving and ticking. "Play here" reloads — the reloaded page claims the save as the newest.
export interface ElsewhereOverlayProps {
  text: string;
  button: string;
  onPlayHere(): void;
}

export function ElsewhereOverlay({ text, button, onPlayHere }: ElsewhereOverlayProps) {
  return (
    <div class="ov-block" role="dialog" aria-modal="true" data-overlay="elsewhere">
      <div class="ov-box">
        <p class="ov-text">{text}</p>
        <button type="button" class="ov-btn" data-hit="elsewhere-play" onClick={onPlayHere}>
          {button}
        </button>
      </div>
    </div>
  );
}
